angular.module(NgAppName).directive('ngHtmlCompile', ['$compile', function($compile) {
	return {
		restrict: 'A',
		replace: true,
		scope: {
			htmlToCompile: '='
		},
		link: function(scope, ele, attrs) {
			var compileHtml = function() {
				ele.html(scope.htmlToCompile);
				$compile(ele.contents())(scope);
			};
			compileHtml();

			scope.$on('updateNgHtmlCompile', function() {
				compileHtml();
			});
		}
	};
}]);
